import { memoEval } from '@salsita-ai/platform-project-sdk/domain';
import { implementAdminCustomExpressions } from '../__generated/admin-implementation.js';
const normalizeCssColor = (value)=>{
    const trimmed = value.trim();
    if (trimmed.startsWith('#')) return trimmed;
    const rgbMatch = trimmed.match(/^(\d{1,3}),(\d{1,3}),(\d{1,3})$/);
    if (rgbMatch) {
        const [r, g, b] = rgbMatch.slice(1).map((n)=>Math.max(0, Math.min(255, Number(n))));
        return `rgb(${r}, ${g}, ${b})`;
    }
    return trimmed;
};
const createColorSwatchUrl = (cssColor)=>{
    const svg = `<svg xmlns='http://www.w3.org/2000/svg' width='42' height='42'><rect width='100%' height='100%' fill='${cssColor}'/></svg>`;
    return `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`;
};
export const adminCustomExpressions = implementAdminCustomExpressions({
    WoodTextureMaterial: {
        $name: memoEval((self)=>[
                self.name
            ], (name)=>{
            return name;
        }),
        $description: (self)=>{
            return self.$woodSwatch?.swatchName ?? '';
        },
        $swatchUrl: (self)=>{
            return self.$woodSwatch?.thumbnailUrl ?? '';
        }
    },
    CabinetWoodTextureMaterial: {
        $woodSwatch: (self)=>self.$woodSwatches[self.materialName]
    },
    CountertopWoodTextureMaterial: {
        $woodSwatch: (self)=>self.$woodSwatches[self.materialName]
    },
    SolidColorMaterial: {
        $name: memoEval((self)=>[
                self.name
            ], (name)=>{
            return name;
        }),
        $description: memoEval((self)=>[
                self.color
            ], (color)=>{
            return color;
        }),
        $swatchUrl: memoEval((self)=>[
                self.color
            ], (color)=>{
            return createColorSwatchUrl(normalizeCssColor(color));
        })
    }
});

//# sourceMappingURL=admin-expressions.js.map